import { React, useEffect, useState, useRef } from 'react';
import { Link, Outlet, Route, useNavigate } from 'react-router-dom';
import ROUTES from '../../nav/Routes';


// Import the necessary modules from swiper
// import { Autoplay, Pagination } from 'swiper';

function About() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // you can use 'auto' for instant scroll
        });
    };

    return (
        <div class="main">

            <div id="hero" class="Starter section dark-background">
                <img src="assets/img/image5.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div class="container ">
                    <div class="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div class="col-xl-6 col-lg-8">
                            <h2>Innovating Logistics & Transportation<span>.</span></h2>
                            <p>Smart, reliable, and tech-driven solutions for modern transport needs.</p>
                        </div>
                    </div>
                </div>
            </div>
            <section id="about" class="about section my-5">
                <div class="container mt-5" data-aos="fade-up" data-aos-delay="100">
                    <div class="row gy-5">
                        <div class="col-lg-6 order-1 order-lg-2">
                            <img src="assets/img/image20.jpeg" class="img-fluid" alt="About Mann Carriers" />
                        </div>
                        <div class="col-lg-6 order-2 order-lg-1 content text-justify">
                            <h3>Who We Are</h3>
                            <p class="fst-italic">
                                At Mann Carriers LLC, we believe in delivering more than just freight — we deliver on trust, responsibility, and long-term impact. With every shipment, every route, and every client relationship, we stand by our core belief:
                                Your trust is our pride.
                                We specialize in Over-the-Road (OTR) dispatch services across the United States, offering tailored logistics solutions backed by real-time communication, professional support, and operational integrity.
                                But our journey doesn’t stop there.
                                We’re also proud to lead the way in eco-conscious logistics. Through initiatives like tree-planting rewards and sustainable planning, we’re doing our part to protect the planet while powering the industry.
                            </p>
                            <h5>What We Offer:</h5>

                            <ul>
                                <li><i class="bi bi-shield-check"></i> <span>Reliable Over-the-Road (OTR) Dispatch Services across the United States.</span></li>
                                <li><i class="bi bi-headset"></i> <span>24/7 Live Support & Real-time Communication.</span></li>
                                <li><i class="bi bi-truck"></i> <span>Professional Load Planning & Route Optimization.</span></li>
                                <li><i class="bi bi-people-fill"></i> <span>Personalized Service for Drivers & Clients.</span></li>
                                <li><i class="bi bi-hand-thumbs-up"></i> <span>Transparent & Ethical Business Practices.</span></li>
                            </ul>

                        </div>
                    </div>
                </div>
            </section>


            <section id="call-to-action" class="call-to-action section dark-background ">

                <img src="assets/img/image5.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />

                <div class="container py-5 my-4" >
                    <div class="row justify-content-center" data-aos="zoom-in" data-aos-delay="100">
                        <div class="col-xl-10">
                            <div class="text-center">
                                <h3><i class="bi bi-people me-2"></i>Join the Mann Carriers Family</h3>
                                <p>
                                    We’re always looking for passionate professionals — drivers, dispatchers, and logistics experts — who want to grow with purpose.
                                </p>
                                <Link class="cta-btn" to={ROUTES.contact.name} onClick={scrollToTop}><i class="bi bi-send-check-fill me-2"></i>Contact Us Today</Link>
                            </div>
                        </div>
                    </div>
                </div>

            </section>






            {/* <section id="driving-change" class="section my-5 bg-offwhite">
                <div class="container" data-aos="fade-up" data-aos-delay="100">
                    <div class="text-center mb-4">
                        <h3><i class="bi bi-globe-americas me-2"></i>Driving Change — On the Road & In the World</h3>
                        <p class="fst-italic">Eco-conscious logistics for a sustainable future.</p>
                    </div>
                    <div class="row gy-4 justify-content-center">
                        <div class="col-md-6">
                            <div class="d-flex align-items-start">
                                <i class="bi bi-tree-fill fs-2 text-success me-3"></i>
                                <div>
                                    <h5>Plant a Tree, Leave a Legacy</h5>
                                    <p>We reward sustainability by planting trees through our signature initiative, creating a lasting environmental impact.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex align-items-start">
                                <i class="bi bi-recycle fs-2 text-success me-3"></i>
                                <div>
                                    <h5>Sustainable Logistics Planning</h5>
                                    <p>We optimize routes with fuel efficiency in mind and reduce carbon emissions wherever possible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}



            <section id="stats" className="stats section bg-offwhite">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4 align-items-center justify-content-between">


                        <div className="col-lg-6">
                            <h3 className="fw-bold fs-2 mb-3">Driving Change — On the Road & In the World</h3>

                            <p>
                                <p class="fst-italic">From eco-friendly programs like our "Plant a Tree, Leave a Legacy" initiative to conscious logistics planning, we take responsibility for the environment we all share.
                                </p>
                            </p>

                            <div className=" gy-4">
                                <div className="col-lg-10">
                                    <div className="stats-item d-flex">
                                        <i class="bi bi-recycle flex-shrink-0"></i>
                                        <div>
                                            <h5>Sustainable Logistics Planning</h5>
                                            <p class="p-0"><strong>We optimize routes</strong> with fuel efficiency in mind and reduce carbon emissions wherever possible.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="alert alert-success">
                                    <div className="col-lg-10 mt-4">
                                        <div className="stats-item d-flex">
                                            <i className="bi bi-tree-fill flex-shrink-0"></i>
                                            <div>
                                                <h5>Plant a Tree, Leave a Legacy</h5>
                                                <p class="p-0"><strong>We reward sustainability</strong> by planting trees through our signature initiative, creating a lasting environmental impact.</p>

                                            </div>
                                        </div>
                                    </div>
                                    <Link class="tree-btn mt-4" to={ROUTES.planttree.name} onClick={scrollToTop}><i class="bi bi-tree-fill me-2"></i>Plant a Tree</Link>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-5">
                            <img src="assets/img/image3.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>










            <section id="stats" className="stats section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4 align-items-center justify-content-between">
                        <div className="col-lg-5">
                            <img src="assets/img/image10.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" className="img-fluid" />
                        </div>

                        <div className="col-lg-6">
                            <h3 className="fw-bold fs-2 mb-3">Proven Performance in Transport & Logistics</h3>
                            <p>
                                We deliver results backed by experience, technology, and a passionate team that drives your cargo forward with care and precision.
                            </p>

                            <div className="row gy-4">
                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-person-heart flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Happy Clients</strong> <span>Trusted partnerships built over time</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-truck-front flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="521" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Deliveries Completed</strong> <span>Nationwide & on-time</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-clock-history flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="1453" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Support Hours</strong> <span>Round-the-clock assistance</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-person-lines-fill flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Team Members</strong> <span>Skilled & dedicated staff</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>



        </div>
    )
}

export default About;